'use strict';

const translations = {
  en: {
    'title.1': 'KAT VR | No.1 VR Treadmill Technology Innovator',
    'option.1': 'En',
    'option.2': 'Ua',
    'option.3': 'De',
    'a.1': 'About',
    'a.2': 'Tech',
    'a.3': 'Benefits',
    'a.4': 'Contact',
    'a.5': 'Language',
    'a.6': 'FAQ',
    'a.7': 'Help',
    'li.1': 'English',
    'li.2': 'Ukrainian',
    'li.3': 'Deutsche',
    'h2.1': 'HOW CAN WE ',
    'span.1': 'HELP ',
    'span.101': 'YOU?',
    'p.1':
      'Welcome to our help center. Our goal is to make the process of getting acquainted and purchase as easy and pleasant as possible. Need help with your KAT VR loco product? Many product questions can be resolved by reviewing our Product Support. ',
    'a.8': 'FAQs',
    'p.2':
      'Please also feel free to  directly should you need anything further. We’re happy to help. ',
    'a.9': 'Contact Us',
    'a.10': 'Instruction manual',
    'a.11': 'Where to go for a warranty',
    'a.12': 'Service Policy',
    'a.13': '+86-0571-86105373',
    'a.14': 'global@katvr.com',
    'a.15': 'overseas@katvr.com',
    'h1.1': 'THE NEW START OF',
    'span.2': 'VR LOCOMOTION',
    'p.3':
      'Discover the most comprehensive VR Locomotion system, and unlock\n            infinite motion in any games on any platforms!',
    'p.4': '1200$',
    'p.5': 'Play Video',
    'button.1': 'Buy now',
    'button.2': 'More',
    'h2.2': 'MORE THAN',
    'span.3': 'GAMING!',
    'p.6': 'This also made for people who are interested in...',
    'h3.1': 'EDUCATION',
    'p.7': 'Create aducational simulations, trainings and much more with',
    'span.4': '...',
    'span.5': 'unlimited virtual space and minimum physical space',
    'h3.2': 'REAL ESTATE',
    'p.8': 'Design architectural projects in a deeply realistic environment',
    'span.6': '...',
    'span.7': 'allowing visitors to freely walk around, and feel their vibe',
    'h3.3': 'FITNESS',
    'p.9': 'Combine business with pleasure, and discover countless ways',
    'span.8': '...',
    'span.9': 'to stay fit while playing your favorite VR Games!',
    'h3.4': 'SOCIAL INTERACTIONS',
    'p.10': 'Hang out with your friends in the virtual world when you can’t',
    'span.10': '...',
    'span.11': 'meet space requirements',
    'h2.3': 'ABOUT',
    'span.12': 'PRODUCT',
    'div.1': '1/5',
    'div.2': '2/5',
    'div.3': '3/5',
    'div.4': '4/5',
    'div.5': '5/5',
    'button.3': 'Previous',
    'button.4': 'Next',
    'div.6':
      'KAT loco is a foot-based VR locomotion system that gives complete \n          physical control over lower-body actions, allowing you to freely walk,\n          run, and carry out just any other movement in virtual reality.',
    'p.11': 'Play Video',
    'div.7': 'Hello,',
    'h2.4': 'NICE TO MEET',
    'span.13': 'YOU!',
    'div.8':
      'KAT VR is an independent company dedicated to the research, \n          development, and sales of VR Locomotion products and solutions.\n          Founded in 2013, we have quickly grown to become one of the world’s\n          leading professional suppliers of VR games’ & simulations’ equipment',
    'h2.5': 'TECH',
    'span.14': 'SPECS',
    'h3.5': 'SENSOR',
    'p.12':
      'Weight: 35g/1.23oz each  \n    Dimension: 50mm/1.97in 24mm/0.94in  \n    Light: LED lights',
    'h3.6': 'CONNECTION',
    'p.13':
      'Wireless: Bluetooth 4.2  \n    Signal range: 5m  \n   Receiver: USB 2.0 and above',
    'h3.7': 'BATTERIES',
    'p.14':
      'Type: Lithium-ion polymer batteries \n      Capacity: 370mAh   \n   Battery life: 10h of continuous use 150 hours on stand by \n     Charging: Fast charging - 1 hour \n     Charging voltage and current: 5V = 0.5A',
    'h2.6': 'WHY',
    'span.15': 'KAT LOCO?',
    'h3.8': 'UNIVERSALLY COMPATIBLE',
    'p.15':
      'KAT Loco offers universal compatibility across all major VR headsets and',
    'span.16': 'platforms...',
    'span.17': '...',
    'span.18':
      'platforms allowing you to play any VR game with support for   Free Locomotion',
    'h3.9': 'VR/PC CONTROL PANEL',
    'p.16':
      'Our Multifunctional Software allows for quick access to KAT Loco’s',
    'span.19': 'control panel both from...',
    'span.20': '...',
    'span.21':
      'control panel both from a computer desktop, and directly   from your VR headset.',
    'h3.10': 'WIRELESS SENSORS',
    'p.17':
      'What makes it even more advanced, KAT Loco is entirely wireless, and',
    'span.22': 'comes with a...',
    'span.23': '...',
    'span.24':
      'comes with a complete system of algorithms, super durable   batteries and more!',
    'button.5': 'Buy now',
    'p.18': 'Have any questions?',
    'h2.7': 'GET IN',
    'span.25': 'TOUCH',
    'p.19': 'Our manager will reply you within 15 minutes',
    'a.16': '+86-0571-86105373',
    'a.17': 'global@katvr.com',
    'a.18': 'overseas@katvr.com',
    'label.1': 'Name*',
    'label.2': 'Email*',
    'label.3': 'Phone*',
    'label.4': 'Message',
    'a.19': 'About',
    'a.20': 'Tech',
    'a.21': 'Benefits',
    'a.22': 'Contact',
    'a.23': '+86-0571-86105373',
    'a.24': 'global@katvr.com',
    'a.25': 'overseas@katvr.com',
  },

  ua: {
    'title.1': 'KAT VR | Новатор №1 у технології VR доріжок',
    'option.1': 'En',
    'option.2': 'Ua',
    'option.3': 'De',
    'a.1': 'Про нас',
    'a.2': 'Технології',
    'a.3': 'Переваги',
    'a.4': 'Контакти',
    'a.5': 'Мова',
    'a.6': 'ЧаПи',
    'a.7': 'Допомога',
    'li.1': 'Англійська',
    'li.2': 'Українська',
    'li.3': 'Німецька',
    'h2.1': 'ЯК МИ  МОЖЕМО ',
    'span.1': 'ДОПОМОГТИ ',
    'span.101': 'ВАМ?',
    'p.1':
      'Ласкаво просимо до нашого центру підтримки. Наша мета — зробити процес ознайомлення та покупки максимально простим і приємним. Потребуєте допомоги з вашим продуктом KAT VR loco? Багато питань можна вирішити, переглянувши нашу службу підтримки. ',
    'a.8': 'ЧаПи',
    'p.2':
      'Також не соромтеся звертатися безпосередньо, якщо вам знадобиться додаткова допомога. Ми раді допомогти. ',
    'a.9': 'Зв’язатися з нами',
    'a.10': 'Інструкція',
    'a.11': 'Гарантія',
    'a.12': 'Політика обслуговування',
    'a.13': '+86-0571-86105373',
    'a.14': 'global@katvr.com',
    'a.15': 'overseas@katvr.com',
    'h1.1': 'НОВИЙ ПОЧАТОК',
    'span.2': 'VR LOCOMOTION',
    'p.3':
      'Відкрийте для себе найповнішу систему VR Lokomotion та розблокуйте нескінченні рухи у будь-яких іграх на будь-яких платформах!',
    'p.4': '1200$',
    'p.5': 'Переглянути відео',
    'button.1': 'Купити зараз',
    'button.2': 'Більше',
    'h2.2': 'БІЛЬШЕ НІЖ',
    'span.3': 'ГЕЙМІНГ!',
    'p.6': 'Це також для тих, кого цікавить...',
    'h3.1': 'ОСВІТА',
    'p.7': 'Створюйте освітні симуляції, тренінги та багато іншого з',
    'span.4': '...',
    'span.5': 'необмеженим віртуальним простором і мінімальною фізичною площею',
    'h3.2': 'НЕРУХОМІСТЬ',
    'p.8':
      'Проектуйте архітектурні проекти в надзвичайно реалістичному середовищі',
    'span.6': '...',
    'span.7': 'дозволяючи відвідувачам вільно ходити та відчувати атмосферу',
    'h3.3': 'ФІТНЕС',
    'p.9': 'Поєднуйте бізнес із задоволенням і відкривайте незліченні способи',
    'span.8': '...',
    'span.9': 'залишатися в формі під час гри у ваші улюблені VR ігри!',
    'h3.4': 'СОЦІАЛЬНІ ВЗАЄМОДІЇ',
    'p.10': 'Проводьте час із друзями у віртуальному світі, коли не можете',
    'span.10': '...',
    'span.11': 'забезпечити простір для зустрічей',
    'h2.3': 'ПРО',
    'span.12': 'ПРОДУКТ',
    'div.1': '1/5',
    'div.2': '2/5',
    'div.3': '3/5',
    'div.4': '4/5',
    'div.5': '5/5',
    'button.3': 'Попередня',
    'button.4': 'Наступна',
    'div.6':
      'KAT loco — це система VR локомоції, що встановлюється на ноги і дає повний фізичний контроль нижньої частини тіла, дозволяючи вільно ходити, бігати та виконувати будь-які інші рухи у віртуальній реальності.',
    'p.11': 'Переглянути відео',
    'div.7': 'Привіт,',
    'h2.4': 'РАДІ ',
    'span.13': 'ЗНАЙОМСТВУ!',
    'div.8':
      'KAT VR — незалежна компанія, присвячена дослідженню, розробці та продажу продуктів VR локомоції та рішень. Заснована у 2013 році, ми швидко стали одним із провідних професійних постачальників обладнання для VR ігор та симуляцій у світі.',
    'h2.5': 'ТЕХНІЧНІ',
    'span.14': 'ХАРАКТЕРИСТИКИ',
    'h3.5': 'СЕНСОР',
    'p.12':
      'Вага: 35г/1.23унції кожен   \n   Розміри: 50мм/1.97дюйма х 24мм/0.94дюйма   \n   Підсвітка: світлодіодна',
    'h3.6': 'З’ЄДНАННЯ',
    'p.13':
      'Бездротове: Bluetooth 4.2   \n   Дальність: 5м   \n   Приймач: USB 2.0 та вище',
    'h3.7': 'АКУМУЛЯТОРИ',
    'p.14':
      'Тип: літій-полімерні батареї    \n  Ємність: 370мАг   \n   Час роботи: 10 годин безперервно, 150 годин у режимі очікування \n     Швидка зарядка: 1 година   \n   Напруга та струм: 5В = 0.5А',
    'h2.6': 'ЧОМУ',
    'span.15': 'KAT LOCO?',
    'h3.8': 'УСЕСВІТНЯ СУМІСНІСТЬ',
    'p.15':
      'KAT Loco пропонує універсальну сумісність з усіма основними VR гарнітурами та',
    'span.16': 'платформами...',
    'span.17': '...',
    'span.18':
      'платформами, що дозволяють грати у будь-які VR ігри з підтримкою   вільної локомоції',
    'h3.9': 'ПАНЕЛЬ КЕРУВАННЯ VR/PC',
    'p.16':
      'Наше багатофункціональне програмне забезпечення дозволяє швидко   доступати до панелі керування KAT Loco',
    'span.19': 'як з робочого столу...',
    'span.20': '...',
    'span.21': 'як з робочого столу, так і безпосередньо з вашої VR гарнітури.',
    'h3.10': 'БЕЗДРОТОВІ СЕНСОРИ',
    'p.17': 'Ще більш просунуто, KAT Loco повністю бездротовий, та',
    'span.22': 'поставляється з…',
    'span.23': '...',
    'span.24':
      'поставляється з повною системою алгоритмів, надміцними батареями і багато чим іншим!',
    'button.5': 'Купити зараз',
    'p.18': 'Є питання?',
    'h2.7': 'ЗВ’ЯЖІТЬСЯ',
    'span.25': 'З НАМИ',
    'p.19': 'Наш менеджер відповість вам протягом 15 хвилин',
    'a.16': '+86-0571-86105373',
    'a.17': 'global@katvr.com',
    'a.18': 'overseas@katvr.com',
    'label.1': "Ім'я*",
    'label.2': 'Електронна пошта*',
    'label.3': 'Телефон*',
    'label.4': 'Повідомлення',
    'a.19': 'Про нас',
    'a.20': 'Технології',
    'a.21': 'Переваги',
    'a.22': 'Контакти',
    'a.23': '+86-0571-86105373',
    'a.24': 'global@katvr.com',
    'a.25': 'overseas@katvr.com',
  },

  de: {
    'title.1': 'KAT VR | Nr. 1 Innovator der VR-Laufbandtechnologie',
    'option.1': 'En',
    'option.2': 'Ua',
    'option.3': 'De',
    'a.1': 'Über uns',
    'a.2': 'Technik',
    'a.3': 'Vorteile',
    'a.4': 'Kontakt',
    'a.5': 'Sprache',
    'a.6': 'FAQ',
    'a.7': 'Hilfe',
    'li.1': 'Englisch',
    'li.2': 'Ukrainisch',
    'li.3': 'Deutsch',
    'h2.1': 'WIE KÖNNEN WIR  IHNEN ',
    'span.1': 'HILFE ',
    'span.101': 'HELFEN?',
    'p.1':
      'Willkommen in unserem Help Center. Unser Ziel ist es, den Prozess des Kennenlernens und Kaufens so einfach und angenehm wie möglich zu gestalten. Benötigen Sie Hilfe mit Ihrem KAT VR loco Produkt? Viele Fragen können durch unsere Produktsupport-Seite beantwortet werden. ',
    'a.8': 'FAQs',
    'p.2':
      'Bitte zögern Sie nicht, uns direkt zu kontaktieren, falls Sie weitere Hilfe benötigen. Wir helfen Ihnen gerne. ',
    'a.9': 'Kontaktieren Sie uns',
    'a.10': 'Bedienungsanleitung',
    'a.11': 'Garantie',
    'a.12': 'Servicebedingungen',
    'a.13': '+86-0571-86105373',
    'a.14': 'global@katvr.com',
    'a.15': 'overseas@katvr.com',
    'h1.1': 'DER NEUE START VON',
    'span.2': 'VR LOCOMOTION',
    'p.3':
      'Entdecken Sie das umfassendste VR-Lokomotionssystem und entfesseln Sie unbegrenzte Bewegungen in allen Spielen und auf allen Plattformen!',
    'p.4': '1200$',
    'p.5': 'Video abspielen',
    'button.1': 'Jetzt kaufen',
    'button.2': 'Mehr',
    'h2.2': 'MEHR ALS',
    'span.3': 'GAMING!',
    'p.6': 'Dies ist auch für alle, die sich interessieren für...',
    'h3.1': 'BILDUNG',
    'p.7':
      'Erstellen Sie Ausbildungssimulationen, Schulungen und vieles mehr mit',
    'span.4': '...',
    'span.5': 'unbegrenztem virtuellem Raum und minimalem physischen Platz',
    'h3.2': 'IMMOBILIEN',
    'p.8':
      'Entwerfen Sie Architekturprojekte in einer äußerst realistischen Umgebung',
    'span.6': '...',
    'span.7':
      'und ermöglichen Sie Besuchern, frei zu laufen und die Atmosphäre zu spüren',
    'h3.3': 'FITNESS',
    'p.9':
      'Kombinieren Sie Geschäft mit Vergnügen und entdecken Sie unzählige Möglichkeiten',
    'span.8': '...',
    'span.9': 'fit zu bleiben, während Sie Ihre Lieblings-VR-Spiele spielen!',
    'h3.4': 'SOZIALE INTERAKTIONEN',
    'p.10':
      'Verbringen Sie Zeit mit Freunden in der virtuellen Welt, wenn Sie nicht',
    'span.10': '...',
    'span.11': 'genügend Platz für Treffen haben',
    'h2.3': 'ÜBER',
    'span.12': 'PRODUKT',
    'div.1': '1/5',
    'div.2': '2/5',
    'div.3': '3/5',
    'div.4': '4/5',
    'div.5': '5/5',
    'button.3': 'Zurück',
    'button.4': 'Weiter',
    'div.6':
      'KAT loco ist ein fußbasiertes VR-Lokomotionssystem, das vollständige physische Kontrolle über die Unterkörperbewegungen bietet und es Ihnen ermöglicht, frei zu gehen, zu laufen und jede andere Bewegung in der virtuellen Realität auszuführen.',
    'p.11': 'Video abspielen',
    'div.7': 'Hallo,',
    'h2.4': 'SCHÖN KENNENZULERNEN',
    'span.13': 'SIE!',
    'div.8':
      'KAT VR ist ein unabhängiges Unternehmen, das sich der Forschung, Entwicklung und dem Vertrieb von VR-Lokomotionsprodukten und -lösungen widmet. Gegründet 2013, haben wir uns schnell zu einem der weltweit führenden professionellen Anbieter von VR-Spiel- und Simulationsausstattung entwickelt.',
    'h2.5': 'TECHNISCHE',
    'span.14': 'DATEN',
    'h3.5': 'SENSOR',
    'p.12':
      'Gewicht: 35g/1,23oz pro Stück   \n   Abmessungen: 50mm/1,97in 24mm/0,94in  \n    Beleuchtung: LED-Lichter',
    'h3.6': 'VERBINDUNG',
    'p.13':
      'Drahtlos: Bluetooth 4.2  \n    Reichweite: 5m   \n   Empfänger: USB 2.0 und höher',
    'h3.7': 'AKKUS',
    'p.14':
      'Typ: Lithium-Ionen-Polymer-Akkus   \n   Kapazität: 370mAh  \n    Laufzeit: 10h Dauerbetrieb, 150h Standby   \n   Schnellladung: 1 Stunde    \n  Lade­spannung und ­strom: 5V = 0,5A',
    'h2.6': 'WARUM',
    'span.15': 'KAT LOCO?',
    'h3.8': 'UNIVERSALKOMPATIBEL',
    'p.15':
      'KAT Loco bietet universelle Kompatibilität mit allen großen VR-Headsets und',
    'span.16': 'Plattformen...',
    'span.17': '...',
    'span.18':
      'Plattformen, die Ihnen das Spielen jedes VR-Spiels mit Unterstützung für freie Lokomotion ermöglichen',
    'h3.9': 'VR/PC-STEUERPANEL',
    'p.16':
      'Unsere Multifunktionssoftware ermöglicht schnellen Zugriff auf das KAT Loco Steuerpanel',
    'span.19': 'sowohl vom Desktop aus...',
    'span.20': '...',
    'span.21': 'sowohl vom Desktop als auch direkt von Ihrem VR-Headset aus.',
    'h3.10': 'DRAHTLOSE SENSOREN',
    'p.17':
      'Was es noch fortschrittlicher macht, ist, dass KAT Loco komplett drahtlos ist und',
    'span.22': 'wird mit...',
    'span.23': '...',
    'span.24':
      'geliefert mit einem kompletten System aus Algorithmen, super robusten Akkus und mehr!',
    'button.5': 'Jetzt kaufen',
    'p.18': 'Haben Sie Fragen?',
    'h2.7': 'NEHMEN SIE',
    'span.25': 'KONTAKT AUF',
    'p.19': 'Unser Manager antwortet Ihnen innerhalb von 15 Minuten',
    'a.16': '+86-0571-86105373',
    'a.17': 'global@katvr.com',
    'a.18': 'overseas@katvr.com',
    'label.1': 'Name*',
    'label.2': 'E-Mail*',
    'label.3': 'Telefon*',
    'label.4': 'Nachricht',
    'a.19': 'Über uns',
    'a.20': 'Technik',
    'a.21': 'Vorteile',
    'a.22': 'Kontakt',
    'a.23': '+86-0571-86105373',
    'a.24': 'global@katvr.com',
    'a.25': 'overseas@katvr.com',
  },
};
const burger = document.querySelector('.header__burger');
const nav = document.querySelector('.header__nav');
const closeBtn = document.querySelector('.header__nav-close');
const navBackground = document.querySelector('.header__background');
const newStartVideoDiv = document.querySelector('.new-start__video-container');
const newStartPlayVideoBtn = document.querySelector(
  '.new-start__play-video-button',
);
const newStartCloseVideoBtn = document.querySelector('.new-start__video-close');
const aboutVideoDiv = document.querySelector('.about__video-container');
const aboutPlayVideoBtn = document.querySelector('.about__play-video-button');
const aboutCloseVideoBtn = document.querySelector('.about__video-close');
const hintButton1 = document.querySelector(
  '.tech-specs__hint--1 .tech-specs__hint-button',
);
const hintButton2 = document.querySelector(
  '.tech-specs__hint--2 .tech-specs__hint-button',
);
const hintButton3 = document.querySelector(
  '.tech-specs__hint--3 .tech-specs__hint-button',
);
const hintText1 = document.querySelector(
  '.tech-specs__hint--1 .tech-specs__hint-text',
);
const hintText2 = document.querySelector(
  '.tech-specs__hint--2 .tech-specs__hint-text',
);
const hintText3 = document.querySelector(
  '.tech-specs__hint--3 .tech-specs__hint-text',
);
const hintImage1 = document.querySelector(
  '.tech-specs__hint--1 .tech-specs__hint-image',
);
const hintImage2 = document.querySelector(
  '.tech-specs__hint--2 .tech-specs__hint-image',
);
const hintImage3 = document.querySelector(
  '.tech-specs__hint--3 .tech-specs__hint-image',
);
const menuLangSelect = document.querySelector('.nav__select');
const menuLangButton = document.querySelector('.nav__item--lang');
const navList = document.querySelector('.nav__list');
const menuLangBack = document.querySelector('.nav__select-back');
const menuHelpButton = document.querySelector('.nav__item--help');
const menuHelpClose = document.querySelector('.help__close');
const menuHelp = document.querySelector('.help');
const menuHelpWrapper = document.querySelector('.help-wrapper');
const navLinks = document.querySelectorAll('header .nav__link, .help__link');
const langSelect = document.querySelector('.header__select-control');
const navLangOptions = document.querySelectorAll('.nav__select-option');
const navLangSelect = document.querySelector('.nav__select');
const aboutPrevBtn = document.querySelector(
  '.about__prev-next .prev-next__prev',
);
const aboutNextBtn = document.querySelector(
  '.about__prev-next .prev-next__next',
);
const aboutSlides = document.querySelectorAll('.about__slide');
const aboutDots = document.querySelectorAll('.about__dot');
const aboutUnderline = document.querySelector(
  '.about__prev-next .prev-next__underline-position',
);
const newStartPrevBtn = document.querySelector(
  '.new-start__prev-next .prev-next__prev',
);
const newStartNextBtn = document.querySelector(
  '.new-start__prev-next .prev-next__next',
);
const newStartSlides = document.querySelectorAll('.new-start__image-wrapper');
const newStartUnderline = document.querySelector(
  '.new-start__prev-next .prev-next__underline-position',
);
const slideshowContainer = document.querySelector(
  '.about__slideshow-container',
);
let aboutIndex = 0;
let newStartIndex = 0;
let touchStartX = 0;
const THRESHOLD = 50;

function currentSlide(n) {
  if (n < 1) n = 1;
  if (n > aboutSlides.length) n = aboutSlides.length;

  Array.from(aboutSlides).forEach((s) => (s.style.display = 'none'));
  Array.from(aboutDots).forEach((d) => d.classList.remove('active'));

  aboutSlides[n - 1].style.display = 'block';
  aboutDots[n - 1].classList.add('about__dot--active');
}

function renderAbout() {
  aboutSlides.forEach((s) => (s.style.display = 'none'));
  aboutDots.forEach((d) => d.classList.remove('about__dot--active'));

  aboutSlides[aboutIndex].style.display = 'block';
  aboutDots[aboutIndex].classList.add('about__dot--active');

  aboutUnderline.style.left = `${aboutIndex * (100 / aboutSlides.length)}%`;

  aboutPrevBtn.classList.toggle('prev-next__prev--disabled', aboutIndex === 0);
  aboutNextBtn.classList.toggle(
    'prev-next__next--disabled',
    aboutIndex === aboutSlides.length - 1,
  );
}

aboutPrevBtn.addEventListener('click', () => {
  if (aboutIndex > 0) {
    aboutIndex--;
    renderAbout();
  }
});

aboutNextBtn.addEventListener('click', () => {
  if (aboutIndex < aboutSlides.length - 1) {
    aboutIndex++;
    renderAbout();
  }
});

function renderNewStart() {
  newStartSlides.forEach((s) => (s.style.display = 'none'));

  newStartSlides[newStartIndex].style.display = 'block';

  newStartUnderline.style.left = `${newStartIndex * (100 / newStartSlides.length)}%`;

  newStartPrevBtn.classList.toggle(
    'prev-next__prev--disabled',
    newStartIndex === 0,
  );
  newStartNextBtn.classList.toggle(
    'prev-next__next--disabled',
    newStartIndex === newStartSlides.length - 1,
  );
}

newStartPrevBtn.addEventListener('click', () => {
  if (newStartIndex > 0) {
    newStartIndex--;
    renderNewStart();
  }
});

newStartNextBtn.addEventListener('click', () => {
  if (newStartIndex < newStartSlides.length - 1) {
    newStartIndex++;
    renderNewStart();
  }
});

function changeLanguage(lang) {
  const dict = translations[lang] || translations.en;

  document.querySelectorAll('[data-i18n]').forEach((el) => {
    const key = el.dataset.i18n;
    const translation = dict[key] || translations.en[key] || '';

    if (el.children.length === 0) {
      el.textContent = translation;
    } else {
      const textNodes = Array.from(el.childNodes).filter(
        (n) => n.nodeType === Node.TEXT_NODE,
      );

      const parts = translation.split(/\r?\n|\r|\n/g).map((s) => s.trim());

      textNodes.forEach((node, idx) => {
        node.nodeValue = parts[idx] || '';
      });
    }
  });
}

function onLangChange() {
  const newLang = langSelect.value;
  console.log(newLang);
  localStorage.setItem('lang', newLang);
  changeLanguage(newLang);
}

newStartPlayVideoBtn.addEventListener('click', () => {
  newStartVideoDiv.classList.add('new-start__video-container--open');
});

newStartCloseVideoBtn.addEventListener('click', () => {
  newStartVideoDiv.classList.remove('new-start__video-container--open');
});

aboutPlayVideoBtn.addEventListener('click', () => {
  aboutVideoDiv.classList.add('about__video-container--open');
});

aboutCloseVideoBtn.addEventListener('click', () => {
  aboutVideoDiv.classList.remove('about__video-container--open');
});

burger.addEventListener('click', () => {
  nav.classList.add('header__nav--open');
  document.body.style.overflowY = 'hidden';
  navBackground.classList.add('header__background--open');
});

closeBtn.addEventListener('click', () => {
  nav.classList.remove('header__nav--open');
  document.body.style.overflowY = 'auto';
  navBackground.classList.remove('header__background--open');
});

hintButton1.addEventListener('click', () => {
  if (hintText1.classList.contains('tech-specs__hint-text--open')) {
    hintText1.classList.remove('tech-specs__hint-text--open');
    hintButton1.classList.remove('tech-specs__hint-button--open');
    hintImage1.classList.remove('tech-specs__hint-image--open');
  } else {
    hintText1.classList.add('tech-specs__hint-text--open');
    hintButton1.classList.add('tech-specs__hint-button--open');
    hintImage1.classList.add('tech-specs__hint-image--open');
  }
});

hintButton2.addEventListener('click', () => {
  if (hintText2.classList.contains('tech-specs__hint-text--open')) {
    hintText2.classList.remove('tech-specs__hint-text--open');
    hintButton2.classList.remove('tech-specs__hint-button--open');
    hintImage2.classList.remove('tech-specs__hint-image--open');
  } else {
    hintText2.classList.add('tech-specs__hint-text--open');
    hintButton2.classList.add('tech-specs__hint-button--open');
    hintImage2.classList.add('tech-specs__hint-image--open');
  }
});

hintButton3.addEventListener('click', () => {
  if (hintText3.classList.contains('tech-specs__hint-text--open')) {
    hintText3.classList.remove('tech-specs__hint-text--open');
    hintButton3.classList.remove('tech-specs__hint-button--open');
    hintImage3.classList.remove('tech-specs__hint-image--open');
  } else {
    hintText3.classList.add('tech-specs__hint-text--open');
    hintButton3.classList.add('tech-specs__hint-button--open');
    hintImage3.classList.add('tech-specs__hint-image--open');
  }
});

menuLangButton.addEventListener('click', () => {
  menuLangSelect.classList.add('nav__select--open');
  navList.classList.add('nav__list--hidden');
});

menuLangBack.addEventListener('click', () => {
  menuLangSelect.classList.remove('nav__select--open');
  navList.classList.remove('nav__list--hidden');
});

menuHelpButton.addEventListener('click', () => {
  menuHelp.classList.add('help--open');
  menuHelpWrapper.classList.add('help-wrapper--open');
});

menuHelpClose.addEventListener('click', () => {
  menuHelp.classList.remove('help--open');
  menuHelpWrapper.classList.remove('help-wrapper--open');
  document.body.style.overflowY = 'auto';
});

navLinks.forEach((link) => {
  if (
    link.innerText.trim() !== 'Help' &&
    link.innerText.trim() !== 'Language'
  ) {
    link.addEventListener('click', () => {
      nav.classList.remove('header__nav--open');
      menuHelp.classList.remove('help--open');
      navBackground.classList.remove('header__background--open');
      document.body.style.overflowY = 'auto';
      menuHelpWrapper.classList.remove('help-wrapper--open');
    });
  }

  if (link.innerText.trim() === 'Help') {
    link.addEventListener('click', () => {
      document.body.style.overflowY = 'hidden';
    });
  }
});

navLangOptions.forEach((option) =>
  option.addEventListener('click', () => {
    const newLang = option.dataset.lang;

    localStorage.setItem('lang', newLang);
    changeLanguage(newLang);
    nav.classList.remove('header__nav--open');
    document.body.style.overflowY = 'auto';
    navBackground.classList.remove('header__background--open');
    navLangSelect.classList.remove('nav__select--open');
    navList.classList.remove('nav__list--hidden');
  }),
);

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.contacts__form');
  const fields = Array.from(form.querySelectorAll('.contacts__field')).filter(
    (element) =>
      Array.from(element.children).every(
        (child) => child.dataset.i18n !== 'label.4',
      ),
  );

  function validateField(fieldEl) {
    const input = fieldEl.querySelector('.contacts__input');
    const valid = input.checkValidity();
    const label = fieldEl.querySelector('.contacts__label');

    fieldEl.classList.remove(
      'contacts__field--error',
      'contacts__field--success',
    );

    if (valid) {
      fieldEl.classList.add('contacts__field--success');
      label.textContent = label.dataset.text;
    } else {
      fieldEl.classList.add('contacts__field--error');
      label.textContent = label.dataset.error;
    }

    return valid;
  }

  fields.forEach((fieldEl) => {
    const label = fieldEl.querySelector('.contacts__label');
    const input = fieldEl.querySelector('.contacts__input');
    input.addEventListener('blur', () => validateField(fieldEl));
    input.addEventListener(
      'focus',
      () => (label.textContent = label.dataset.text),
    );
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const allValid = fields.every((fieldEl) => validateField(fieldEl));

    if (allValid) {
      alert('Form submitted successfully!');
      form.reset();
      fields.forEach((f) => f.classList.remove('contacts__field--success'));
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const initial = 'en';
  langSelect.value = initial;
  changeLanguage(initial);
});

slideshowContainer.addEventListener('touchstart', (e) => {
  touchStartX = e.touches[0].clientX;
});

slideshowContainer.addEventListener('touchend', (e) => {
  const touchEndX = e.changedTouches[0].clientX;
  const diffX = touchEndX - touchStartX;

  if (Math.abs(diffX) < THRESHOLD) return;

  if (diffX > 0) {
    if (aboutIndex > 0) {
      aboutIndex--;
    }
  } else {
    if (aboutIndex < aboutSlides.length - 1) {
      aboutIndex++;
    }
  }
  renderAbout();
});

renderNewStart();
renderAbout();
